import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=a27e5768&"
import script from "./page4.vue?vue&type=script&lang=js&"
export * from "./page4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports